import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AllPreviewComps from '../index';
import Modal from '../modal/index.vue';
let BaseNav = class BaseNav extends Vue {
    constructor() {
        super(...arguments);
        this.stickyTopCopy = 0;
        this.activeIndex = 0;
        this.slideLeft = 0;
        this.initX = 0;
        this.initY = 0;
        this.useCenter = false;
        // 非通用属性
        this.activeCompKey = '';
        this.showFilter = false;
        this.filterData = {};
    }
    get navList() {
        let classify = (this.data.classify || []).map(c => {
            c.comps = (c.comps || []).filter(item => {
                return (item.has_auth ||
                    (!item.has_auth && item.filter && !item.filter.hiddenFilterLink));
            });
            return c;
        });
        return classify;
    }
    get navTitle() {
        return `${this.navBgStyle};${this.data.navType
            ? ''
            : `position: sticky; top: ${this.stickyTopCopy || 0}px; z-index: 990;`}${this.useCenter ? 'justify-content: center;' : ''}`;
    }
    get navbarStyle() {
        return `--activeAfter: ${this.data.fontColor}`;
    }
    get navBgStyle() {
        return `background: ${this.data.bgColor || '#00B097'}`;
    }
    get getComp() {
        return item => {
            let compName = item.type.substr(0, 1).toUpperCase() + item.type.substr(1) || 'Empty';
            return AllPreviewComps[compName];
        };
    }
    get allComps() {
        return this.navList.reduce((t, c) => {
            return t.concat(c.comps);
        }, []);
    }
    get activeColor() {
        return `--activeColor: ${this.data.activeColor || '#00B097'}`;
    }
    stickyTopChange(newV) {
        console.log('dddd', newV);
        this.stickyTopCopy = newV;
    }
    mounted() {
        this.isAppTab = this.$route.query.isAppTab || '';
        let dom = this.$refs['grouptitle'];
        try {
            if (this.data.fontAlign === 'center') {
                let left = (dom.scrollWidth - dom.offsetWidth) / 2;
                dom.scrollLeft = left;
                this.useCenter = left === 0 ? true : false;
            }
            else {
                dom.scrollLeft = 0;
            }
        }
        catch { }
        setTimeout(this.exposureEvent, 1111);
    }
    // 由于display: none导致轮播失效，处理该问题（swiper版本过低）
    showComps(comp, index) {
        return comp.lineRule === 'loop' ? this.activeIndex === index : true;
    }
    async activeHandler(index, $event) {
        const width = this.$refs.slideWrap.offsetWidth;
        this.activeIndex = index;
        this.slideLeft = -width * index;
        let rect = this.$refs['group'].getBoundingClientRect();
        if (rect && rect.top < 0 && document.querySelector('.preview-box')) {
            document.querySelector('.preview-box').scrollTop = this.$refs['group'].offsetTop;
        }
        this.clickEvent(this.data, $event);
        this.clickTabEvent(index);
        let cEl = $event.currentTarget;
        await this.$nextTick();
        let liWidth = cEl.scrollWidth;
        let screenWidth = window.screen.width;
        let diffNum = Math.floor((screenWidth - liWidth) / 2);
        let left = cEl.offsetLeft - diffNum;
        let navUl = this.$el.querySelector('.group-title');
        console.log(screenWidth, liWidth, diffNum, left, cEl);
        navUl.scrollTo({
            left: left,
            behavior: 'smooth',
        });
        setTimeout(() => {
            document.getElementsByClassName('preview-box')[0].scrollTop -= 1; //该部分是为了解决视频在ios上封面无法切换的问题，与其余无关
        }, 500);
    }
    // 滑动切换
    touchstart(e) {
        this.initX = e.clientX;
        this.initY = e.clientY;
        const wrap = this.$refs.slideWrap;
        wrap.addEventListener('touchmove', this.touchmove);
        wrap.addEventListener('touchend', this.touchend);
    }
    touchmove(e) {
        const wrap = this.$refs.slideWrap;
        let deltaX = e.clientX - this.initX;
        let deltaY = e.clientY - this.initY;
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
            e.preventDefault();
            if ((this.activeIndex === 0 && deltaX > 0) ||
                (this.activeIndex === this.navList.length - 1 && deltaX < 0))
                return;
            this.slideLeft = deltaX + -this.activeIndex * wrap.offsetWidth;
        }
    }
    touchend() {
        const wrap = this.$refs.slideWrap;
        const initLeft = -this.activeIndex * wrap.offsetWidth;
        if (initLeft - this.slideLeft > 100) {
            this.activeIndex++;
        }
        else if (initLeft - this.slideLeft < -100) {
            this.activeIndex--;
        }
        this.slideLeft = -this.activeIndex * wrap.offsetWidth;
        wrap && wrap.removeEventListener('mousemove', this.touchmove);
        wrap && wrap.removeEventListener('mouseup', this.touchend);
    }
    /**
     * 以下为组件非通用部分，不删除不影响c端交互
     */
    activeComp(type, data, activeCompKey) {
        if (activeCompKey) {
            this.activeCompKey = `${activeCompKey.index}-${activeCompKey.key}`;
        }
        else {
            this.activeCompKey = '';
        }
        this.$emit('compActive', type, data);
    }
    // 电商埋点-微页面组件点击
    async clickEvent(item, e) {
        if (item.type === 'group')
            return;
        if (!item.has_auth) {
            e.stopPropagation();
            this.filterData = item.filter && item.filter.filterLink;
            this.showFilter = true;
        }
        if (!item.title)
            return;
        if ([
            'title',
            'picture',
            'album',
            'video',
            'nav',
            'goods',
            'suspend',
            'coupon',
            'ebook',
            'modal',
            'button',
        ].includes(item.type))
            return;
        await this.uploadEvent.sendRecord('Click_MicroPages_Component', '', {
            PageName: document.title,
            ComponentName: item.title,
            isTabPage: +this.isAppTab ? 'Y' : 'N',
        }, [
            ['p1', 'PageName'],
            ['p2', 'ComponentName'],
            ['p3', 'isTabPage'],
        ], { useCurPageName: +this.isAppTab });
    }
    // 组件曝光事件监听
    exposureEvent() {
        const option = {
            threshold: [0, 0.5],
        };
        let loaded = [];
        let comps = document.querySelectorAll(`.${this.data._id}-comp-item`);
        if (typeof IntersectionObserver !== 'function')
            return;
        let io = new IntersectionObserver(e => {
            e.forEach(el => {
                if (!this.isHidden && el && el.intersectionRatio > 0) {
                    let config = this.allComps.find(c => c._id === el.target.getAttribute('group_comp_item_id'));
                    if (!config)
                        return;
                    if (!loaded.includes(config._id)) {
                        // 电商埋点-微页面组件曝光
                        this.uploadEvent.sendRecord('Exposure_MicroPages_Component', '', {
                            PageName: document.title,
                            ComponentName: config.title,
                            isTabPage: +this.isAppTab ? 'Y' : 'N',
                        }, [
                            ['p1', 'PageName'],
                            ['p2', 'ComponentName'],
                            ['p3', 'isTabPage'],
                        ], { useCurPageName: +this.isAppTab });
                        loaded.push(config._id);
                    }
                }
            });
        }, option);
        comps.forEach(el => io.observe(el));
    }
    async clickTabEvent(index) {
        await this.uploadEvent.sendRecord('Click_MicroPages_Component', '', {
            PageName: document.title,
            ComponentName: '分类分组',
            ContentName: this.navList[index].name,
        }, [
            ['p1', 'PageName'],
            ['p2', 'ComponentName_ContentName'],
        ]);
    }
};
tslib_1.__decorate([
    Prop({ default: () => { } })
], BaseNav.prototype, "data", void 0);
tslib_1.__decorate([
    Prop({ default: () => { } })
], BaseNav.prototype, "uploadEvent", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], BaseNav.prototype, "isHidden", void 0);
tslib_1.__decorate([
    Prop({ default: 0 })
], BaseNav.prototype, "stickyTop", void 0);
tslib_1.__decorate([
    Watch('stickyTop', { immediate: true, deep: true })
], BaseNav.prototype, "stickyTopChange", null);
BaseNav = tslib_1.__decorate([
    Component({
        inheritAttrs: false,
        components: {
            Modal,
        },
    })
], BaseNav);
export default BaseNav;
